.temu-tag-label {
  display: inline-flex;
  align-items: center;
  height: 12px;
  color: #fff;
}

.temu-logo {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}
